import React from 'react';
import { TLanguageIDs } from 'types';
import { availableCountries } from 'appConstants';
import CountryFlag from 'components/CountryFlag/CountryFlag';
import classNames from 'classnames';

interface IProps {
	languageId: TLanguageIDs;
	isActive: boolean;
	isDefault?: boolean;
	hasError?: boolean;
	onClick: () => void;
}

export const LanguageBarItemNew: React.FC<IProps> = ({
	languageId,
	isActive,
	isDefault = false,
	hasError = false,
	onClick,
}) => {
	const { countryCode, languageName } = availableCountries[languageId];
	const containerClasses = classNames(
		'px-4 py-2 border border-solid rounded flex items-center gap-2 text-base whitespace-nowrap select-none',
		{
			'border-blue-05-new bg-blue-05-new font-bold text-white-00-new cursor-default': isActive,
			'border-purple-02-new bg-white-00-new cursor-pointer hover:text-purple-07-new': !isActive,
			'text-red-06-new': !isActive && hasError,
			'text-grey-10-new': !isActive && !hasError,
		},
	);

	return (
		<div className={containerClasses} data-test={`LanguageBarItem-${languageName}`} onClick={onClick}>
			<CountryFlag countryCode={countryCode} size="24px" />
			{languageName}
			{isDefault && ' (Default)'}
		</div>
	);
};
